import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importReturnPortal = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "ReturnPortal" */
                '@perpay-web/fintech/components/screens/ReturnPortal/ReturnPortal'
            ),
    );
